<div class="margin-bottom-5">
  @if (uiConfiguration.showAssignorRegistrationNumbers) {
    <div class="padding-sides-5">
      <div>{{ uiConfiguration.assignorRegistrationNumbersTitle }}</div>
      @if ((lien?.assignorRegistrationNumbers?.length ?? 0) > 0) {
        <div data-testid="lien-details-assignor-registration-numbers-text">
          <ul class="multi-column-list">
            @for (num of lien?.assignorRegistrationNumbers; track num) {
              <li>{{ num }}</li>
            }
          </ul>
        </div>
      } @else {
        <ul>
          <li class="padding-top-5 padding-bottom-5 text-faded">{{ 'lienDetails.noneFound' | transloco: { title: uiConfiguration.assignorRegistrationNumbersTitle.toLowerCase() } }}</li>
        </ul>
      }
    </div>
  }
  @if (uiConfiguration.showAssigneeRegistrationNumbers) {
    <div class="padding-sides-5">
      <div>{{ 'lienDetails.assigneeRegistrationNumbers' | transloco }}</div>
      @if ((lien?.assigneeRegistrationNumbers?.length ?? 0) > 0) {
        <div data-testid="lien-details-assignee-registration-numbers-text">
          <ul class="multi-column-list">
            @for (num of lien?.assigneeRegistrationNumbers; track num) {
              <li>{{ num }}</li>
            }
          </ul>
        </div>
      } @else {
        <ul>
          <li class="text-faded">{{ 'lienDetails.noAssigneeRegistrationNumbersFound' | transloco }}</li>
        </ul>
      }
    </div>
  }
  @if (uiConfiguration.showQCFormTypeID) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.formType' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-form-type-text">{{ lien?.qcFormTypeID }}</span>
    </div>
  }
  @if ((uiConfiguration.showTerm || uiConfiguration.showInfinityTerm) && (lien?.isInfiniteTerm || lien?.term || uiConfiguration.noTermText) ) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.term' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-term-text">{{ lien?.isInfiniteTerm ? "INFINITY" : order.lien?.term ?? uiConfiguration.noTermText ?? '' }}</span>
    </div>
  }
  @if (uiConfiguration.showTerm && uiConfiguration.registryDefinedTerm) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.term' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-term-text">{{ uiConfiguration.registryDefinedTerm }}</span>
    </div>
  }
  @if (uiConfiguration.showExpiryDate && lien?.expiryDate && !isHistorical()) {
    <div class="flex-container">
      <span class="flex-item-3">{{ getExpiryDateHeader() }}</span>
      <span class="flex-item-4" data-testid="lien-details-expiry-date-text">{{ $safeNavigationMigration(lien?.expiryDate) | localizedDate: 'yyyy-MM-dd' }}</span>
    </div>
  }
  @if (shouldShowExpectedExpiry && this.expectedExpiryDate) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.expectedExpiryDate' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-expected-expiry-date-text">{{ expectedExpiryDate | localizedDate: "yyyy-MM-dd" }} </span>
    </div>
  }
  @if (uiConfiguration.showAmount && $safeNavigationMigration(lien?.amount) !== null && $safeNavigationMigration(lien?.amount) !== undefined) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.amount' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-amount-text">{{ $safeNavigationMigration(lien?.amount) | currency }}</span>
    </div>
  }
  @if ((uiConfiguration.showSigningCity ||
    uiConfiguration.showSigningJurisdiction ||
    uiConfiguration.showSigningCountry) &&
    (lien?.signingCity ||
    lien?.signingJurisdiction ||
    lien?.signingCountry) ) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.signingLocation' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-signing-location-text">{{ lien?.signingCity }} {{ lien?.signingJurisdiction }} {{ lien?.signingCountry }}
      </span>
    </div>
  }
  @if (uiConfiguration.showSigningDate && lien?.signingDate) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.signingDate' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-signing-date-text">{{ $safeNavigationMigration(lien?.signingDate) | localizedDate: "yyyy-MM-dd" }} </span>
    </div>
  }
  @if (uiConfiguration.showSurrenderDate && lien?.surrenderDate) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.surrenderDate' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-surrender-date">{{ $safeNavigationMigration(lien?.surrenderDate) | localizedDate: "yyyy-MM-dd" }} </span>
    </div>
  }
  @if (uiConfiguration.showHasDebtorAcknowledged) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.debtorHasAcknowledgedTheDebt' | transloco }}</span>
      <span class="flex-item-4" data-testid="debtor-has-acknowledged-debt-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.hasDebtorAcknowledged ?? false"></mat-checkbox></span>
    </div>
  }
  @if (uiConfiguration.showStillHavePossession) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.stillHavePossession' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-possession-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.stillHavePossession ?? false"></mat-checkbox></span>
    </div>
  }
  @if (uiConfiguration.showVehicleReleasedDate && lien?.vehicleReleasedDate) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.vehicleReleasedDate' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-vehicle-released-date-text">{{ $safeNavigationMigration(lien?.vehicleReleasedDate) | localizedDate: "yyyy-MM-dd" }} </span>
    </div>
  }
  @if (uiConfiguration.showWorkLastCompletedDate && lien?.workLastCompletedDate) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.workLastCompletedDate' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-work-last-completed-text">{{ $safeNavigationMigration(lien?.workLastCompletedDate) | localizedDate: "yyyy-MM-dd" }} </span>
    </div>
  }
  @if (uiConfiguration.showProvidedPartsOrAccessories) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.partsProvidedOrAccessories' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-parts-provided-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.providedPartsOrAccessories ?? false"></mat-checkbox></span>
    </div>
  }
  @if (uiConfiguration.showPartsProvidedDate && lien?.partsProvidedDate) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.partsProvidedDate' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-parts-provided-date-text">{{ $safeNavigationMigration(lien?.partsProvidedDate) | localizedDate: "yyyy-MM-dd" }} </span>
    </div>
  }
  @if (uiConfiguration.showServiceLastRendered && lien?.serviceLastRendered) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.serviceLastRendered' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-service-last-rendered-text">{{ $safeNavigationMigration(lien?.serviceLastRendered) | localizedDate: "yyyy-MM-dd" }} </span>
    </div>
  }
  @if (uiConfiguration.showDateOfLien && lien?.dateOfLien) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.dateOfLien' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-date-of-lien-text">{{ $safeNavigationMigration(lien?.dateOfLien) | localizedDate: "yyyy-MM-dd" }} </span>
    </div>
  }
  @if (uiConfiguration.showRIN) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'common.labels.rin' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-rin-text">{{ getRIN() }}</span>
    </div>
  }
  @if (uiConfiguration.showFileNumber && isBasic()) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'common.labels.fileNumber2' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-file-number-text">{{ lien?.fileNumber }}</span>
    </div>
  }
  @if (uiConfiguration.showSumOfHypothec && lien?.sumOfHypothec) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.sumOfHypothec' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-sum-of-hypothetic-text">{{ lien?.sumOfHypothec }}</span>
    </div>
  }
  @if (uiConfiguration.showAuthorityText) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.authorityText' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-authority-text">{{ lien?.authorityText }}</span>
    </div>
  }
  @if (uiConfiguration.showPerfectionInAnotherJurisdiction) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.perfectionInAnotherJurisdiction' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-perfection-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.perfectionInAnotherJurisdiction ?? false"></mat-checkbox></span>
    </div>
  }
  @if (uiConfiguration.showPurchaseMoneySecurityInterest) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.purchaseMoneySecurityInterest' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-purchase-money-security-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.purchaseMoneySecurityInterest ?? false"></mat-checkbox></span>
    </div>
  }
  @if (uiConfiguration.showTrustIndenture) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.trustIndenture' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-trust-ind-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.trustIndenture ?? false"></mat-checkbox></span>
    </div>
  }
  @if (uiConfiguration.showReceiverAppointment) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.receiverAppointment' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-receiver-appointment-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.receiverAppointment ?? false"></mat-checkbox></span>
    </div>
  }
  @if (uiConfiguration.showMaturityDate && (order.lien?.maturityDate ?? false)) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.maturityDate' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-maturity-date-text">{{ $safeNavigationMigration(order.lien?.maturityDate) | localizedDate: "yyyy-MM-dd" }}</span>
    </div>
  }
  @if (uiConfiguration.showMaturityDate) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.noFixedMaturityDate' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-no-fixed-maturity-date-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.noFixedMaturityDate ?? false"></mat-checkbox></span>
    </div>
  }
  @if (uiConfiguration.showConsumerGoods) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.consumerGoods' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-consumer-goods-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.consumerGoods ?? false"></mat-checkbox></span>
    </div>
  }
  @if (uiConfiguration.showInventory) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.inventory' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-inventory-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.inventory ?? false"></mat-checkbox></span>
    </div>
  }
  @if (uiConfiguration.showEquipment) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.equipment' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-equipment-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.equipment ?? false"></mat-checkbox></span>
    </div>
  }
  @if (uiConfiguration.showAccounts) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.accounts' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-accounts-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.accounts ?? false"></mat-checkbox></span>
    </div>
  }
  @if (uiConfiguration.showOther) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.other' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-other-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.other ?? false"></mat-checkbox></span>
    </div>
  }
  @if (uiConfiguration.showMVIncluded) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.mvIncluded' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-mv-included-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.mvIncluded ?? false"></mat-checkbox></span>
    </div>
  }
  @if (uiConfiguration.showCautionFiling) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'lienDetails.cautionFiling' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-details-caution-filing-checkbox"><mat-checkbox disabled="true"
      [checked]="order.lien?.cautionFiling ?? false"></mat-checkbox></span>
    </div>
  }
</div>
@if (uiConfiguration.showNatureOfServiceRendered && order.lien?.natureOfServiceRendered) {
  <div class="flex-item">
    <div class="bold">{{ 'lienDetails.natureOfServiceRendered' | transloco }}</div>
    <div class="preserve-line-breaks" data-testid="nature-ofservice-rendered-text">{{ order.lien.natureOfServiceRendered }}</div>
  </div>
}
@if (uiConfiguration.showAdditionalInformation && order.lien?.additionalInformation) {
  <div class="flex-item">
    <div class="bold">{{ 'lienDetails.additionalInformation' | transloco }}</div>
    <div class="preserve-line-breaks" data-testid="lien-details-additional-information-text">{{ order.lien.additionalInformation }}</div>
  </div>
}
@if (uiConfiguration.showCourtOrder && order.lien?.courtOrder) {
  <div class="flex-item">
    <div class="bold">{{ 'lienDetails.courtOrder' | transloco }}</div>
    <div class="preserve-line-breaks" data-testid="lien-details-court-order-text">{{ order.lien?.courtOrder }}</div>
  </div>
}
@if (uiConfiguration.showOtherChanges && order.lien?.otherChanges) {
  <div class="flex-item">
    <div class="bold">{{ 'lienDetails.otherChanges' | transloco }}</div>
    <div class="preserve-line-breaks" data-testid="lien-details-other-changes-text">{{ order.lien?.otherChanges }}</div>
  </div>
}